import NextHead from 'next/head';
import Script from 'next/script';
import { Site } from '@99designs/site-navigation/lib/Site';
import { Locale } from '../../../shared/lib/locale';

interface Props {
    title: string;
    description: string;
    site: Site;
    meta?: any;
}

export default function Head({ title, description, site, meta }: Props) {
    const slackAppId = (site.siteConfig as any)['slackappid'];
    const dataLayerBootstrap = `
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(${JSON.stringify({
            region: Locale.getRegion(site.get('locale')),
            isLiveChatEnabled: (site.siteConfig as any)['livechatenabled'],
        })});
    `;

    return (
        <>
            <NextHead>
                <title>{`${title} | 99designs`}</title>

                <meta key="og:title" property="og:title" content={title} />
                <meta key="og:description" property="og:description" content={description} />
                <meta name="description" content={description} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="cleartype" content="on" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
                <meta httpEquiv="X-UA-TextLayoutMetrics" content="natural" />
                <meta httpEquiv="Accept-CH" content="DPR, Viewport-Width, Width" />
                <meta name="format-detection" content="telephone=no" />
                <meta name="apple-mobile-web-app-title" content="99designs" />
                <meta name="author" content="99designs" />
                {meta}

                <link rel="icon" sizes="16x16 32x32" href="/favicon.ico?v=1" />
                <link rel="mask-icon" href="/pinned-tab-icon.svg" color="#fe5f50" />
                <link rel="apple-touch-icon" href="/touch-icon-iphone.png" />
                <link rel="apple-touch-icon" sizes="76x76" href="/touch-icon-ipad.png" />
                <link rel="apple-touch-icon" sizes="120x120" href="/touch-icon-iphone-retina.png" />
                <link rel="apple-touch-icon" sizes="152x152" href="/touch-icon-ipad-retina.png" />

                <link
                    rel="preload"
                    as="font"
                    crossOrigin=""
                    type="font/woff2"
                    href="https://assets.99static.com/shared/fonts/Graphik-Medium.woff2"
                />
                <link
                    rel="preload"
                    as="font"
                    crossOrigin=""
                    type="font/woff2"
                    href="https://assets.99static.com/shared/fonts/Graphik-Regular.woff2"
                />
                {/* Slack app suggestion https://api.slack.com/docs/slack-apps-suggestions */}
                {slackAppId && <meta name="slack-app-id" content={slackAppId} />}
            </NextHead>

            <Script id="marketing-data-layer" strategy="beforeInteractive">
                {dataLayerBootstrap}
            </Script>
        </>
    );
}
